module.exports = "/_next/static/images/perks-jumper-a94a84ac32990482e19e3659dd99ca57.png";